import { EditableRow } from './EditableRow';
import { EditableCell } from './EditableCell';

export const editableComponents = {
  body: {
    row: EditableRow,
    cell: EditableCell,
  },
};
